var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[_c('DataTableAG',{attrs:{"deleteparam":"retailerids","columns":_vm.columns,"width":"850px","height":"750px","getcontentpath":_vm.retailersspath,"buttonList":['Muokkaa'],"jsonobject":"retailers","retailerCopyEnabled":""},on:{"pressed-button1":_vm.editRetailer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }